import {
  ISimpleCRUDServiceFactory,
  IModelMapper,
  IParamMapper
} from "../../../service/SimpleCRUDServiceFactory";
import { RequestArgs } from "../../../service/HttpService";

export default class CreateResourceInteractor<T> {
  private serviceFactory: ISimpleCRUDServiceFactory<T>;

  constructor({ simpleCRUDServiceFactory }: any) {
    this.serviceFactory = simpleCRUDServiceFactory;
  }

  async execute(
    basePath: string,
    ModelMapper: IModelMapper<T>,
    ParamMapper: IParamMapper<T>,
    model: T,
    args?: RequestArgs,
    form?: boolean
  ) {
    return await this.serviceFactory
      .create({
        basePath,
        ModelMapper,
        ParamMapper
      })
      .createResource(model, args, form);
  }
}
